import { createFileRoute } from '@tanstack/react-router'
import { EmailConfirmPage } from '../components/email-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/bestaetigen')({
  head: () => noIndexRouteHead('emailConfirm', 'de'),
  component: EmailConfirmPage,
})
